import React, { useState } from "react";
import { Link } from "react-router-dom";
import dropdownIcon from "../../assets/images/dropdown.png";
import arrowDown from "../../assets/svg/icon-arrow-down.svg";

import styles from "../../css/resizable.css";

import { Panel, PanelGroup } from "react-resizable-panels";
import ResizeHandler from "../../ResizeHandler";

const FooterGeneral = () => {
  const [data, setData] = useState([
    { sklad: "Текст для сайта", fizOstatok: 0, logOstatok1: 0, logOstatok2: 0 },
    { sklad: "1. ОПЕРАТИВНЫЙ", fizOstatok: 0, logOstatok1: 0, logOstatok2: 0 },
    {
      sklad: "2. Барнаул. Производство",
      fizOstatok: 0,
      logOstatok1: 0,
      logOstatok2: 0,
    },
    {
      sklad: "2. Холодный станочный",
      fizOstatok: 0,
      logOstatok1: 0,
      logOstatok2: 0,
    },
    {
      sklad: "2. Искитим. Производство",
      fizOstatok: 0,
      logOstatok1: 0,
      logOstatok2: 0,
    },
    { sklad: "212. Омск", fizOstatok: 0, logOstatok1: 0, logOstatok2: 0 },
    { sklad: "213. Кемерово", fizOstatok: 0, logOstatok1: 0, logOstatok2: 0 },
    {
      sklad: "3. Холодный накопитель",
      fizOstatok: 0,
      logOstatok1: 0,
      logOstatok2: 0,
    },
    {
      sklad: "5. Теплый станочный",
      fizOstatok: 0,
      logOstatok1: 0,
      logOstatok2: 0,
    },
    { sklad: "6. Новый", fizOstatok: 0, logOstatok1: 0, logOstatok2: 0 },
    {
      sklad: "7. Производственный",
      fizOstatok: 0,
      logOstatok1: 0,
      logOstatok2: 0,
    },
  ]);

  const [data2, setData2] = useState([
    {
      type: "Последняя закупка",
      price: "960 000,00",
      currency: "руб",
      rub: "960 000",
      usd: "9 891,46",
      eur: "9 123,65",
      contractor: "Третье лицо",
      date: "13.04.2021 14:02:04",
      status: "",
    },
    {
      type: "Средняя себестоимость",
      price: "960 000,00",
      currency: "руб",
      rub: "960 000",
      usd: "9 891,46",
      eur: "9 123,65",
      contractor: "Третье лицо",
      date: "13.04.2021 14:02:04",
      status: "",
    },
  ]);

  return (
    <footer className="generalFooter">
      <div></div>
      <div className="upper">
        <div className="upper-group">
          <label htmlFor="quantity">Прогноз: кол-во</label>
          <input type="text" name="quantity" />
        </div>
        <div className="upper-group">
          <label htmlFor="date">метод</label>
          <select name="date">
            <option>Пргнозная дата</option>
            <option>Option2</option>
            <option>Option3</option>
          </select>
        </div>
        <Link to="/">Рассчитать</Link>
      </div>

      <PanelGroup direction="horizontal" autoSaveId="footer-horizontal-group" className="generalFooter-panel">
        {/* Left Panel */}
        <Panel className={`${styles.Panel}`}>
          <div className="footer-upper__left">
            <div className="footer-dropzone">
              <img src={dropdownIcon} alt="Dropdown Icon" />
            </div>
          </div>
        </Panel>

        <ResizeHandler className="resize-div-wrapper"/>

        {/* Middle Panel - Table for first dataset */}
        <Panel className={`${styles.Panel}`}>
          <div className="footer-lower__middle">
            <table className="footer-lower__table">
              <thead>
                <tr>
                  <td>Склад</td>
                  <td>Физически остаток</td>
                  <td>Логический остаток</td>
                  <td>Логический остаток</td>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="gray-cell">{item.sklad}</td>
                    <td className="cyan-cell">{item.fizOstatok}</td>
                    <td className="green-cell">{item.logOstatok1}</td>
                    <td className="white-cell">{item.logOstatok2}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>

        <ResizeHandler className="resize-div-wrapper"/>

        {/* Right Panel - Table for second dataset */}
        <Panel className={`${styles.Panel}`}>
          <div className="footer-lower__right">
            <table className="footer-lower__table2">
              <thead>
                <tr>
                  <td>
                    <span>Тип цены</span>
                    <span>
                      <img
                        src={arrowDown}
                        className="footer-lower__icon"
                        alt="ArrowDown"
                      />
                    </span>
                  </td>
                  <td>Цена</td>
                  <td>Вал.</td>
                  <td>руб.</td>
                  <td>$</td>
                  <td>EUR</td>
                  <td>Контрагент</td>
                  <td>Дата цены</td>
                  <td>Состояние</td>
                </tr>
              </thead>
              <tbody>
                {data2.map((row, index) => (
                  <tr key={index}>
                    <td>{row.type}</td>
                    <td>{row.price}</td>
                    <td>{row.currency}</td>
                    <td>{row.rub}</td>
                    <td>{row.usd}</td>
                    <td>{row.eur}</td>
                    <td>{row.contractor}</td>
                    <td>{row.date}</td>
                    <td>{row.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>
      </PanelGroup>

      <div className="footer-lower">
        <div className="footer-lower__texts">
          <p className="footer-lower__text">Драгунов М.В..</p>
          <p className="footer-lower__text">Версия: 10,0,16,9</p>
          <p className="footer-lower__text">0,06+0,46+0,05 сек.</p>
        </div>
        <div className="footer-lower__deviders">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </footer>
  );
};

export default FooterGeneral;
